import { Component, Inject, OnInit } from '@angular/core';
import { AuthService } from '@src/services';

@Component({
  selector: 'authCallbackRefresh',
  template: require('./auth-callback.component.html'),
  styles: []
})
export class AuthCallbackComponent implements OnInit {

  constructor(private authService: AuthService, @Inject('$state') private $state: any) {}
public userToken:string = "";
    async ngOnInit() {
    await this.authService.completeAuthentication();
    //console.log("test2")
    this.$state.go('app.authorized.projects');
    //console.log(this.userToken)
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authentication/auth-callback/auth-callback.component.ts